import Base64 from '@/lib/base64.js';

const getGlobal = variable => {
  return window.App && window.App[variable] !== undefined ? window.App[variable] : null;
}

export const defaultState = () => ({
  countries: [],
  country: null,
  timezones: getGlobal('timezones') ? JSON.parse(Base64.decode(getGlobal('timezones'))) : null,
  momentLocale: getGlobal('momentLocale'),
  momentDateFormat: getGlobal('momentDateFormat'),
  momentTimeFormat: getGlobal('momentTimeFormat'),
  supportedLanguages: [],
  defaultLanguage: null,
  validationErrors: {}
});

const state = defaultState();

export default state;
